import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export default class DemosController extends Controller {
  @tracked hrEvents = [
    {
      id: '1',
      title: 'Vacaciones - Juan Pérez',
      start: '2025-08-15',
      end: '2025-08-20',
      extendedProps: {
        type: 'vacation',
        employeeId: 'emp-001',
        status: 'approved'
      }
    },
    {
      id: '2',
      title: 'Reunión de equipo',
      start: '2025-08-12T10:00:00',
      end: '2025-08-12T11:30:00',
      extendedProps: {
        type: 'meeting',
        department: 'development'
      }
    },
    {
      id: '3',
      title: 'Día festivo',
      start: '2025-09-15',
      allDay: true,
      extendedProps: {
        type: 'holiday'
      }
    },
    {
      id: '4',
      title: 'Capacitación - React',
      start: '2025-08-20T14:00:00',
      end: '2025-08-20T17:00:00',
      extendedProps: {
        type: 'training',
        instructor: 'external'
      }
    },
    {
      id: '5',
      title: 'Vacaciones - Alejandra Hidalgo',
      start: '2025-09-15',
      end: '2025-09-20',
      extendedProps: {
        type: 'vacation',
        employeeId: 'emp-002',
        status: 'approved'
      }
    },
    {
      id: '6',
      title: 'Reunión de equipo',
      start: '2025-09-12T11:30:00',
      end: '2025-09-12T12:00:00',
      extendedProps: {
        type: 'meeting',
        department: 'development'
      }
    },
    {
      id: '7',
      title: 'FactorRH Portal - Avances',
      start: '2025-10-01T07:00:00',
      end: '2025-10-01T08:00:00',
      extendedProps: {
        type: 'training',
        instructor: 'external'
      }
    },
  ];

  @tracked canEdit = true;
  @tracked isLoading = false;
  @tracked calendarApi = null; // Referencia a la API del calendario

  // === EVENT HANDLERS ===

  @action
  handleNewEvent(dateInfo) {
    console.log('Nueva fecha seleccionada:', dateInfo);

    // Crear evento temporal
    const newEvent = {
      id: `temp-${Date.now()}`,
      title: `Nuevo evento`,
      start: dateInfo.start,
      end: dateInfo.end,
      allDay: dateInfo.allDay,
      extendedProps: {
        type: 'meeting',
        status: 'pending'
      }
    };

    // Agregar al array - el modifier se actualizará automáticamente
    this.hrEvents = [...this.hrEvents, newEvent];
    alert('Evento creado - revisar consola para detalles');
  }

  @action
  handleEventDetails(event) {
    console.log('Evento clickeado:', event);
    alert(`Evento: ${event.title}\nTipo: ${event.extendedProps.type}`);
  }

  @action
  handleEventMove(moveInfo) {
    console.log('Evento movido:', moveInfo);

    // Actualizar el evento en el array
    const eventIndex = this.hrEvents.findIndex(e => e.id === moveInfo.event.id);
    if (eventIndex !== -1) {
      const updatedEvents = [...this.hrEvents];
      updatedEvents[eventIndex] = {
        ...updatedEvents[eventIndex],
        start: moveInfo.event.start,
        end: moveInfo.event.end
      };
      this.hrEvents = updatedEvents;
    }

    alert('Evento actualizado exitosamente');
  }

  @action
  handleEventResize(resizeInfo) {
    console.log('Evento redimensionado:', resizeInfo);

    // Actualizar duración del evento
    const eventIndex = this.hrEvents.findIndex(e => e.id === resizeInfo.event.id);
    if (eventIndex !== -1) {
      const updatedEvents = [...this.hrEvents];
      updatedEvents[eventIndex] = {
        ...updatedEvents[eventIndex],
        start: resizeInfo.event.start,
        end: resizeInfo.event.end
      };
      this.hrEvents = updatedEvents;
    }

    alert('Evento redimensionado exitosamente');
  }

  @action
  setupCalendarRef(calendarApi) {
    console.log('Calendario inicializado correctamente');
    this.calendarApi = calendarApi;
  }

  @action
  handleCalendarError(error) {
    console.error('Error en el calendario:', error);
    alert('Error al cargar el calendario. Revisar consola.');
  }

  @action
  setLoadingState(isLoading) {
    this.isLoading = isLoading;
    console.log('Estado de carga del calendario:', isLoading);
  }

  // === MÉTODOS PARA CONTROLAR EL CALENDARIO ===

  @action
  goToNext() {
    this.calendarApi?.next();
  }

  @action
  goToPrevious() {
    this.calendarApi?.prev();
  }

  @action
  goToToday() {
    this.calendarApi?.today();
  }

  @action
  changeView(viewName) {
    this.calendarApi?.changeView(viewName);
  }

  @action
  addNewEvent() {
    const newEvent = {
      id: `manual-${Date.now()}`,
      title: 'Evento manual',
      start: new Date(),
      extendedProps: {
        type: 'meeting',
        status: 'confirmed'
      }
    };

    this.hrEvents = [...this.hrEvents, newEvent];
  }

  @action
  removeEvent(eventId) {
    this.hrEvents = this.hrEvents.filter(event => event.id !== eventId);
  }
}